((_) => {
  window.addEventListener('load', () => {
    setTimeout(() => {
      ScrollTrigger.sort();
      ScrollTrigger.refresh();
    }, 500);
  });
  window.addEventListener('resize', _.throttle(() => {
    gsap.matchMediaRefresh();
    setTimeout(() => {
      ScrollTrigger.sort();
      ScrollTrigger.refresh();
    }, 500);
  }, 200));
})(window.lodash);
